<template>
    <TopNav></TopNav>
    <h1>Days Between Dates Calculator</h1>
    <fieldset>
        <legend>Days Between Dates Calculator</legend>
        <label for="start-date">Start Date:</label> <input type="date" v-model="startDate" id="start-date">
        <br>
        <label for="end-date">End Date:</label> <input type="date" v-model="endDate" id="end-date">
        <br><br>
        Difference: <span class="blue">{{ difference() }}</span>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import moment from 'moment'

export default {
    name: "DaysBetweenDates",
    data() {
        return {
            startDate: "",
            endDate: "",
        }
    },
    components: {
        TopNav
    },
    methods: {
        difference: function () {
            let a = moment(this.startDate);
            let b = moment(this.endDate);
            let diffDays = b.diff(a, 'days', true);
            let days = new Number(diffDays);
            let word = "day";
            if (days > 1) {
                word = "days";
            }
            let localString = days.toLocaleString('en-US')
            return `${localString} ${word}`;
        }
    }
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 110px;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
